<div class="page-container" [class.has-footer]="showReady">
  <div *ngIf="showReady || showWaiting || waitMode" class="avatar-container">
    <img class="avatar" src="{{ user.avatar }}" />
    <p><strong>{{ user.name }}</strong></p>

    <div *ngIf="showReady">
      <p>Wait until all users are logged in and then click Ready!</p>
    </div>

    <p *ngIf="waitMode">Hang tight until your friends submit their answers.</p>
    <p *ngIf="showWaiting">Sit tight and relax...</p>
  </div>

  <div *ngIf="questionText !== '' && !waitMode">
    <h1>{{ questionText }}</h1>
    <div class="choices-container">
      <button *ngFor="let choice of questionChoices"  mat-raised-button color="primary" class="choice full-width" [disabled]="disableButtons" (click)="submissionHandler(choice)">{{ choice }}</button>
    </div>

    <p *ngIf="showTimer">
      Time Left: <pbg-timer #timer (timerChange)="timerHandler($event)" [endTime]="expiration" [timeLimit]="maxTime"></pbg-timer>
    </p>
  </div>
</div>


<div class="footer-bar-container" *ngIf="showReady">
  <div class="footer-bar-content">
    <button *ngIf="showReady" mat-raised-button color="primary" class="ready-button full-width" (click)="onReadyHandler()">Ready!</button>
  </div>
</div>
